import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

export const useAuthLogoStyles = makeStyles(() => ({
  logoLink: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
  logo: {
    width: '65%',
    height: 'auto',
    objectFit: 'contain' as const,
  },
}));
